import {FunctionComponent} from 'react';
import AppleImg from '../assets/images/icons/app-store-brands-solid-full.svg?react';
import CalendarImg from '../assets/images/icons/calendar-light-full.svg?react';
import GooglePlayImg from '../assets/images/icons/google-play-brands-solid-full.svg?react';
import LinkImg from '../assets/images/icons/link-external-light-full.svg?react';
import VideoImg from '../assets/images/icons/video-light-full.svg?react';
import FileImg from '../assets/images/icons/file-light-full.svg?react';
import PhoneImg from '../assets/images/icons/phone-light-full.svg?react';
import EnvelopeImg from '../assets/images/icons/envelope-light-full.svg?react';
import LinkedinImg from '../assets/images/socials/linkedin.svg?react';
import {createIconComponent} from '../components/Ui/icons';

const LinkIcon = createIconComponent(LinkImg);
const DocumentIcon = createIconComponent(FileImg);
const VideoIcon = createIconComponent(VideoImg);
const CalendarIcon = createIconComponent(CalendarImg);
const AppleIcon = createIconComponent(AppleImg);
const GooglePlayIcon = createIconComponent(GooglePlayImg);
const PhoneIcon = createIconComponent(PhoneImg);
const EmailIcon = createIconComponent(EnvelopeImg);
const LinkedinIcon = createIconComponent(LinkedinImg);

type LinkIcon = {
    name: string;
    image: FunctionComponent;
    scheme?: string;
};

const linkIcons: Record<string, LinkIcon> = {
    link: {name: 'Link', image: LinkIcon},
    document: {name: 'Document', image: DocumentIcon},
    video: {name: 'Video', image: VideoIcon},
    calendar: {name: 'Calendar', image: CalendarIcon},
    apple: {name: 'Apple', image: AppleIcon},
    googlePlay: {name: 'Google Play', image: GooglePlayIcon},
    linkedin: {name: 'LinkedIn', image: LinkedinIcon},
    phone: {name: 'Phone', image: PhoneIcon, scheme: 'tel:'},
    email: {name: 'Email', image: EmailIcon, scheme: 'mailto:'},
};

export default linkIcons;
